import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const RewardsTitleModal = ({ onDismiss, show }) => {
  const { t } = useTranslation();

  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title">{t('Rewards and Clues')}</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <p>
          {t(`If you wish to provide a reward or clue specifically for this challenge,
          add it here. After the player succesfully completes the challenge, this
          will be added to their rewards and clues section.`)}
        </p>
        <ul>
          <li>
            {t(`A reward can be a coupon with a barcode, an illustration, a graphical
            clue, or any number of creative things.`)}
          </li>
          <li>{t(`Titles are limited to 255 characters.`)}</li>
          <li>{t(`Supports Personalization.`)}</li>
        </ul>
      </div>
      <div className="modal-footer">
        <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t(`Close`)}
        </Button>
      </div>
    </Modal>
  )
};

export default RewardsTitleModal;
